import { Command } from "./DotPadProtocal";

const DotPadSendType = {
    ALL_LINE: 'ALL_LINE',
    SINGLE_LINE: 'SINGLE_LINE',
    ALL_PARTIAL: 'ALL_PARTIAL',
    SINGLE_PARTIAL: 'SINGLE_PARTIAL'
};

const DotPadSendMakeModel = {
    getSendData(sendType, lineList, line) {
        var sendData = ""
        switch (sendType) {
            case DotPadSendType.ALL_LINE : 
                sendData = this.makeTotalLineData(lineList)
                break
            case DotPadSendType.SINGLE_LINE :
                sendData = this.makeSingleLineData(line)
                break
            case DotPadSendType.ALL_PARTIAL : 
                sendData = this.makeTotalPartialData(lineList)
                break
            case DotPadSendType.SINGLE_PARTIAL : 
                sendData = this.makeSinglePartialData(line)
                break
        }

        return sendData
    },
    makeSingleLineData(line) {
        let hexString = line.getSendData()
        let data = this.decimalToHex(line.getStartCellIndex()) + hexString                                                                                                                                                                                                                                                                                                                                                                                                          
        return this.makePacket(data, line.getLineId(), line.getSeqNum(), Command.requestDisplayLine)
    },
    makeTotalLineData(lineList) {
        var hexString = ""
        for (let i = 1; i < lineList.length; i++) {
            hexString += lineList[i].getLineData()
        }
        let data = this.decimalToHex(0) + hexString
        return this.makePacket(data, 1, lineList[1].getSeqNum(), Command.requestDisplayLine)
    },
    makeSinglePartialData(line) {
        let hexString = line.getSendData()
        let startX = line.getStartCellIndex()
        let endX = startX + (hexString.length / 2)
        let data = this.decimalToHex(startX) + this.decimalToHex(endX) + hexString
        
        return this.makePacket(data, line.getLineId(), line.getSeqNum(), Command.requestDisplayPartial)
    },
    makeTotalPartialData(lineList) {
        let startLine = -1;
        let endLine = -1;
        let startX = 999;
        let endX = -1;

        for (let i = 1; i < lineList.length; i++) {
            const line = lineList[i];
            if (line.getRequestReady()) {
                const start = line.getStartCellIndex();
                const end = start + (line.getSendData().length / 2);
    
                if (startLine < 0) startLine = i;
                if (startX > start) startX = start;
                if (endX < end) endX = end;
    
                endLine = i;
            }
        }

        let hexString = "";

        if (startLine > -1) {
            for (let i = startLine; i <= endLine; i++) {
                const currentData = lineList[i];
                const str1 = currentData.getLineData();
                const data = str1.slice(startX * 2, endX * 2);
                hexString += data;
            }

            const data = this.decimalToHex(startX) + this.decimalToHex(endX) + hexString;

            return this.makePacket(data, startLine, lineList[1].getSeqNum(), Command.requestDisplayPartial);
        }

        return null;
    },
    makePacket(data, lineId, seqNum, command) {
        const length = data.length / 2

        let packet = "AA55" // SYNC BYTE
            + this.decimalToHex(5 + length, 4) // (Header(10) ) + DataCount - (SYNC BYTE(2) + LEN(2))
            + this.decimalToHex(lineId, 2)
            + command
            + seqNum // Mode (GrapicMode: 0x00, TextMode: 0x80)
            + data;
        packet += this.checksum(this.hexToBytes(packet.substring(8)))
        return this.hexStringToArrayBuffer(packet);
    },
    /**
     * Convert a hex string to an ArrayBuffer.
     *
     * @param {string} hexString - hex representation of bytes
     * @return {ArrayBuffer} - The bytes in an ArrayBuffer.
     */
    hexStringToArrayBuffer(hexString) {
        // remove the leading 0x
        hexString = hexString.replace(/^0x/, '');

        // ensure even number of characters                                                                                                                                                                                                                                                                                                                   
        if (hexString.length % 2 !== 0) {
            console.warn('WARNING: expecting an even number of characters in the hexString');
        }

        // check for some non-hex characters
        let bad = hexString.match(/[G-Z\s]/i);
        if (bad) {
            console.warn('WARNING: found non-hex characters', bad);
        }

        // split the string into pairs of octets
        let pairs = hexString.match(/[\dA-F]{2}/gi);

        // convert the octets to integers
        if (pairs != null)  {
            let integers = pairs.map(function (s) {
                return parseInt(s, 16);
            });

            let array = new Uint8Array(integers);

            return array.buffer;
        } else {
            return null;
        }
    },
    checksum(test_data) {
        let check = 0xA5;

        for (let i = 0; i < test_data.length; i++) {
            check = check ^ test_data[i]
        }

        return ('0' + (check & 0xFF).toString(16)).slice(-2);
    },
    decimalToHex(d, padding = 2) {
        return Number(d).toString(16).padStart(padding, "0");
    },
    hexToBytes(hex) {
        const bytes = [];
        for (let c = 0; c < hex.length; c += 2)
            bytes.push(parseInt(hex.substr(c, 2), 16));
        return bytes;
    }
}

export {
    DotPadSendMakeModel,
    DotPadSendType
};